export const LOAD_ID = 'LOAD_ID';
export const LOAD_FILE_ID = 'LOHI_LOAD_FILE_ID';
